var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"uploadImg"},[_c('input',{ref:"inputfile",staticClass:"inputfiles",attrs:{"type":"file","id":"addimgfiles","accept":"image/jpg,image/jpeg,image/png"},on:{"change":_vm.upload}})])
}
var staticRenderFns = []

export { render, staticRenderFns }